// DS: i3.2
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Add: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 11.8995C20 12.4518 19.5523 12.8995 19 12.8995L13.0006 12.8993L13 19C13 19.5098 12.6185 19.9305 12.1254 19.9922L12 20C11.4872 20 11.0645 19.614 11.0067 19.1166L11 19L10.9994 12.8993L5 12.8995C4.44772 12.8995 4 12.4518 4 11.8995C4 11.3472 4.44772 10.8995 5 10.8995L10.9994 10.8982L11 5C11 4.4902 11.3815 4.0695 11.8746 4.00779L12 4C12.5128 4 12.9355 4.38604 12.9933 4.88338L13 5L13.0006 10.8982L19 10.8995C19.5523 10.8995 20 11.3472 20 11.8995Z"
          fill="currentColor"
        ></path>
      </svg>
    </IconWrap>
  );
};
Add.displayName = 'Add';

export default Add;
